<template>
    <div class="download-page">
        <section class="top-contentBox">
            <h1 class="page-title_top centerText">Beny improves quality of life</h1>
            <p class="page-top_message centerText marginText">
                You can choose your favorite charity or donate to the idea you support. <br/>
                The Earth can be a better place with you.
            </p>
            <div class="default_Btn w164">See how</div>
            <div class="topLong_icon"></div>
        </section>
        <section class="middle-contentBox">
            <div class="mid_center">
                <h2 class="bold_primaryText centerText">
                    Download Beny today and connect with <br/>
                    hundreds of your colleagues.
                </h2>
                <div class="mid_btmBox">
                    <div class="mid_btmLeft">
                        <div class="bold_primaryText marginTop54">
                            Start redeeming <br/>
                            benefits today
                        </div>
                        <p class="primaryText margin_mid">
                            Download Beny on your smartphone, and get <br/>
                            instant access to thousands of hand-picked <br/>
                            benefits and articles.
                        </p>
                        <div class="download_btn-group">
                            <div class="default_Btn googleBtn"></div>
                            <div class="default_Btn iosBtn"></div>
                        </div>
                    </div>
                    <img class="mid_btmRight" src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/4da69587891d47fc966269cb049e3a8c.png" />
                </div>
            </div>
        </section>
        <div class="svgLine_box">
            <svg
            preserveAspectRatio="none"
            viewBox="-450 -450 900 900"
            xmlns="http://www.w3.org/2000/svg"
            style="fill:#302E2C; width: 100%; height: 90px;"
            >
                <path d='M-466,-11 C0,-769 381,-148 453,-5'/>
            </svg>
        </div>
        <section class="footer-contentBox">
            <div class="fot_center">
                <div class="footer_cardBox">
                    <img src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/80221220620e4ec08da745c7925b5399.png" class="footerCard_img left25" alt="">
                    <div class="footCard_item leftAuto">
                        <div class="bold_primaryText marginTop26">
                            Sign up with your <br/>
                            work email address
                        </div>
                        <p class="primaryText margin_fot">
                            Lorem ipsum dolor sit amet, consectetur <br/>
                            adipiscing elit. Aliquam sit amet vehicula orci. <br/>
                            Duis sed laoreet erat. Integer rutrum metus ex.
                        </p>
                        <div class="dashedLine"></div>
                        <div class="primaryText">
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                            Aliquam sit amet vehicula orci. Duis sed laoreet erat. <br/>
                            Integer rutrum metus ex."
                        </div>
                        <div class="userInfo_box">
                            <img class="userIcon" src="../../assets/home/checked.png" alt="">
                            Lucas Horne,<div class="userJob_box"> Product Manager</div>
                        </div>
                    </div>
                </div>
                <div class="footer_cardBox" style="margin:161px 0 156px 0">
                    <div class="footCard_item">
                        <div class="bold_primaryText marginTop129">
                            Check the articles <br/>
                            and redeem benefits
                        </div>
                        <p class="primaryText margin_fot">
                            Lorem ipsum dolor sit amet, consectetur <br/>
                            adipiscing elit. Aliquam sit amet vehicula orci. <br/>
                            Duis sed laoreet erat. Integer rutrum metus ex.
                        </p>
                        <div class="dashedLine"></div>
                        <div class="primaryText">
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                            Aliquam sit amet vehicula orci. Duis sed laoreet erat. <br/>
                            Integer rutrum metus ex."
                        </div>
                        <div class="userInfo_box">
                            <img class="userIcon" src="../../assets/home/checked.png" alt="">
                            Thomas Stevens,<div class="userJob_box"> UX/UI Designer</div>
                        </div>
                    </div>
                    <img src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/c076234d72214718b26d3108d3c491cb.png" class="footerCard_img2" alt="">
                </div>
                <div class="footer_cardBox">
                    <img src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/7e837900c24141599da3a103a6b5d241.png" class="footerCard_img3" alt="">
                    <div class="footCard_item leftAuto">
                        <div class="bold_primaryText marginTop76">
                            Track progress and <br/>
                            donate to charity
                        </div>
                        <p class="primaryText margin_fot">
                            Lorem ipsum dolor sit amet, consectetur <br/>
                            adipiscing elit. Aliquam sit amet vehicula orci. <br/>
                            Duis sed laoreet erat. Integer rutrum metus ex.
                        </p>
                        <div class="dashedLine"></div>
                        <div class="primaryText">
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                            Aliquam sit amet vehicula orci. Duis sed laoreet erat. <br/>
                            Integer rutrum metus ex."
                        </div>
                        <div class="userInfo_box">
                            <img class="userIcon" src="../../assets/home/checked.png" alt="">
                            Lucas Horne,<div class="userJob_box"> Product Manager</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fot_middle">
                <div class="fotMid_center">
                    <div class="bold_primaryText">
                        What makes Beny <br/>
                        different
                    </div>
                    <div class="fotMid_secondBox marginCenter">
                        <div class="beny_cardBox">
                            <img src="../../assets/works/beny1.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                Features that make <br/>
                                a big difference
                            </div>
                            <p class="beny_card-text">
                                Briefly expand on how this <br/>
                                will help your customers.
                            </p>
                        </div>
                        <div class="beny_cardBox marginTB">
                            <img src="../../assets/works/beny2.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                It's automated, as <br/>
                                it always should be
                            </div>
                            <p class="beny_card-text">
                                Briefly expand on how this <br/>
                                will help your customers.
                            </p>
                        </div>
                        <div class="beny_cardBox">
                            <img src="../../assets/works/beny3.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                It's measurable and <br/>
                                data-driven
                            </div>
                            <p class="beny_card-text">
                                Briefly expand on how this <br/>
                                will help your customers.
                            </p>
                        </div>
                    </div>
                    <div class="fotMid_secondBox">
                        <div class="beny_cardBox">
                            <img src="../../assets/works/beny4.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                Detailed all time <br/>
                                statistics
                            </div>
                            <p class="beny_card-text">
                                Briefly expand on how this <br/>
                                will help your customers.
                            </p>
                        </div>
                        <div class="beny_cardBox marginTB">
                            <img src="../../assets/works/beny5.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                Unique employees <br/>
                                management system
                            </div>
                            <p class="beny_card-text">
                                Briefly expand on how this <br/>
                                will help your customers.
                            </p>
                        </div>
                        <div class="beny_cardBox">
                            <img src="../../assets/works/beny6.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                We're here for you <br/>
                                whatever you need
                            </div>
                            <p class="beny_card-text">
                                Briefly expand on how this <br/>
                                will help your customers.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carousel_box">
                <h3 class="bold_primaryText centerText margin40">
                    What our lovely users <br/>
                    say about us
                </h3>
                <carouselCard/>
            </div>
            <section class="footerBox">
                <div class="footerBox_main">
                    <div class="centerFooter">
                        <div class="footerLeft">
                            <h2 class="footTitle">Download Beny App</h2>
                            <p class="footText">
                                Get unlimited access to 10,000+ of Beny’s <br/>
                                top benefits for you and your family.
                            </p>
                            <div class="download_btn-group">
                                <div class="default_Btn googleBtn"></div>
                                <div class="default_Btn iosBtn"></div>
                            </div>
                        </div>
                        <div class="footerRight"></div>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
import carouselCard from '../common/card-carousel.vue'
export default {
    components:{carouselCard}
}
</script>

<style lang="scss" scoped>
.download-page{
    .top-contentBox{
        width: 100%;
        height: 634px;
        background-color: #f1dadd;
        padding: 127px 0 0 0;
        position: relative;
        .marginText{
            margin: 18px 0 27px 0;
        }
        .w164{
            width: 164px;
            margin: 0 auto 50px auto;
        }
        .topLong_icon{
            width: 100%;
            height: 371px;
            background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/32f743450f68436fb749d4e3bbbf85e6.png') no-repeat;
            background-size: cover;
            background-position-x: -187px;
            overflow: hidden;
        }
    }
    .middle-contentBox{
        padding: 185px 0 95px 0;
        .mid_center{
            width: 1080px;
            margin: 0 auto;
            .mid_btmBox{
                display: flex;
                margin-top: 120px;
                .mid_btmLeft{
                    .marginTop54{
                        margin-top: 54px;
                    }
                    .margin_mid{
                        margin: 20px 0 24px;
                    }
                }
                .mid_btmRight{
                    width: 451px;
                    min-width: 451px;
                    height: 517px;
                    margin-left: auto;
                }
            }
        }
    }
    .footer-contentBox{
        margin-top: -53px;
        padding-top: 96px;
        background: linear-gradient(180deg, #302E2C 0%, rgba(48, 46, 44, 0) 100%);
        .fot_center{
            width: 1080px;
            margin: 0 auto;
            .footer_cardBox{
                overflow: hidden;
                display: flex;
                .footerCard_img{
                    width: 451px;
                    min-width: 451px;
                    height: 517px;
                }
                .footerCard_img2{
                    width: 661px;
                    min-width: 661px;
                    height: 681px;
                    margin-left: 13.4%;
                }
                .footerCard_img3{
                    width: 425px;
                    min-width: 425px;
                    height: 517px;
                }
                .footCard_item{
                    .margin_fot{
                        margin-top: 20px;
                    }
                    .marginTop26{
                        margin-top: 26px;
                    }
                    .marginTop76{
                        margin-top: 76px;
                    }
                    .marginTop129{
                        margin-top: 129px;
                    }
                    .dashedLine{
                        width: 420px;
                        height: 0px;
                        border: 1px dashed #FFFFFF;
                        opacity: 0.18;
                        margin: 31px 0 24px 0;
                    }
                    .userInfo_box{
                        display: flex;
                        margin-top: 24px;
                        height: 40px;
                        align-items: center;
                        font-size: 16px;
                        color: #FFFFFF;
                        font-weight: bold;
                        .userIcon{
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            margin-right: 10px;
                        }
                        .userJob_box{
                            font-size: 15px;
                            font-weight: normal;
                            opacity: 0.8;
                            margin:0 0 0 5px;
                        }
                    }
                }
                .left25{
                    margin-left: -25px;
                }
                .leftAuto{
                    margin-left: auto;
                }
            }
        }
        .fot_middle{
            margin: 112px 40px 90px 40px;
            width: calc(100% - 80px);
            background:#4e4c4a;
            border-radius: 0px;
            .fotMid_center{
                width: 1080px;
                margin: 0 auto;
                padding: 78px 0 93px 0;
                display: flex;
                .fotMid_secondBox{
                    .beny_cardBox{
                        .beny_icon{
                            height: 44px;
                        }
                        .beny_card-title{
                            font-size: 22px;
                            font-family: Lora-Roman, Lora;
                            font-weight: normal;
                            line-height: 27px;
                            color: #FFFFFF;
                            opacity: 1;
                            margin: 24px 0 12px 0;
                        }
                        .beny_card-text{
                            font-size: 17px;
                            font-weight: 400;
                            line-height: 21px;
                            color: #FFFFFF;
                            opacity: 0.8;
                        }
                    }
                    .marginTB{
                        margin: 60px 0;
                    }
                }
                .marginCenter{
                    margin: 0 156px 0 88px;
                }
            }
        }
    }
    .carousel_box{
        width: 1080px;
        margin: 0 auto;
        .margin40{
            margin:0 0 40px 0;
        }
    }
    .footerBox{
        width: 100%;
        padding: 0 40px;
        background: #3A3835;
        .footerBox_main{
            height: 461px;
            background: #F1DADD;
            opacity: 1;
            box-sizing: border-box;
            border-radius: 0px;
            margin-top: 190px;
        }
        .centerFooter{
            display: flex;
            width: 1113px;
            margin: 0 auto;
            .footerLeft{
                .footTitle{
                    margin-top: 132px;
                    height: 52px;
                    font-size: 52px;
                    font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                    font-weight: 900;
                    color: #3A3835;
                    line-height: 67px;
                    color: #3A3835;
                    opacity: 1;
                }
                .footText{
                    margin: 18px 0 24px 0;
                    font-size: 18px;
                    font-family: Assistant-Medium, Assistant;
                    font-weight: 500;
                    color: #3A3835;
                    line-height: 22px;
                }
                .footerBtn{
                    font-size: 17px;
                    font-family: Assistant-Bold, Assistant;
                    font-weight: bold;
                    color: #3A3835;
                    width: 222px;
                    margin: 0;
                }
            }
            .footerRight{
                margin-left: auto;
                margin-top: 59px;
                width: 503px;
                min-width: 503px;
                height: 593px;
                background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/f93e41de3dd74738b31a5740cd69dcf6.png') no-repeat;
                background-size: contain;
                opacity: 1;
                border-radius: 8px;
            }
        }
    }
    .download_btn-group{
        display: flex;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/works/download.vue